import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { ORDER_PAYMENT_TYPE } from '@pos-app/data';
import { UntypedFormControl, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CoreUiModule } from '../../../../../../../../libs/core-ui/src/lib/core-ui.module';
import { AsyncPipe, NgIf } from '@angular/common';
import { BehaviorSubject } from 'rxjs';
@Component({
    selector: 'app-orders-eftpos',
    templateUrl: './orders-eftpos.component.html',
    styleUrls: ['./orders-eftpos.component.scss'],
    imports: [CoreUiModule, FormsModule, ReactiveFormsModule, NgIf, AsyncPipe]
})
export class OrdersEftposComponent implements OnChanges {
  @Input() _id: string;
  @Input() loadAmount: number;
  @Input() outstanding: number;
  @Input() eftposDeviceName: string;
  @Input() registerID: string;
  @Input() orderNumber: string;
  @Input() fakeEFTPOSTF: boolean;

  @Output() paymentDetails = new EventEmitter<any>();
  @Output() cancel = new EventEmitter<any>();

  private isLoadingSubject = new BehaviorSubject<boolean>(false);
  isLoading$ = this.isLoadingSubject.asObservable();
  amount = new UntypedFormControl(null, [Validators.required, Validators.pattern(/^-?\d*[.]?\d{0,2}$/)]);

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.loadAmount && this.amount) {
      this.amount.setValue(Number(this.loadAmount));
    }
  }

  makeTransaction(fakeTransactionType?: 'ERROR' | 'PENDING' | 'SUCCESS') {
    if (this.isLoadingSubject.value) {
      return;
    }

    this.isLoadingSubject.next(true);
    this.paymentDetails.emit({
      _id: this._id?.toString(),
      amount: parseFloat(this.amount.value),
      registerID: this.registerID,
      orderNumber: this.orderNumber,
      payInstrument: '?',
      paymentType: ORDER_PAYMENT_TYPE.eftpos,
      eftposDeviceName: this.eftposDeviceName,
      reference: '',
      fakeTransactionType: this.fakeEFTPOSTF?fakeTransactionType:'',
    });
  }
}
``
